import React, { PropTypes } from 'react';
import cx from 'classnames';
import _ from 'lodash';
import ReactDOM from 'react-dom';
import { appContext } from '../../util/decorators';
import validate, { rules } from '../../util/inputValidation.js';

@appContext
export default class Input extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.t = context.app.t;
    this.state = {
      active: false,
      value: props.prefilled || '',
      inputErrors: [],
    };
  }

  componentDidMount() {
    // If the user selected the component or in case of browser prefill before component loaded
    const input = ReactDOM.findDOMNode(this.inputField);
    if (document.activeElement === input || input.value) {
      this.setState({ active: true }); // eslint-disable-line
    }
    if (input.value) {
      // Prefill state with browser's prefilled value
      this.setState({ value: input.value }); // eslint-disable-line
      this.handleChange({ target: input });
    }
  }

  handleFocus() {
    this.setState({ active: true });
  }

  handleBlur() {
    this.setState({ active: false });
  }

  handleChange(evt) {
    const { value } = evt.target;
    const { onChange, name, customValidation } = this.props;
    let inputErrors = [];

    if (customValidation) {
      inputErrors = customValidation(value);
    } else {
      inputErrors = validate(name, value);
    }

    const formValue = inputErrors.length ? '' : value;
    this.setState({ value, inputErrors }, onChange(formValue));
  }

  renderErrors() {
    const { t } = this;
    const { required, hideErrors } = this.props;
    const { inputErrors } = this.state;

    let errors = [];
    if (!hideErrors) {
      errors = _(inputErrors)
        .map((inputError, idx) => (
          <div className="input-error" key={idx}>{t(inputError)}</div>
        ))
        .concat(
          required && !inputErrors.length
            ? <div key={'empty'} className="input-error">
                {t(rules.notEmpty.msg)}
              </div>
            : [],
        )
        .value();
    }
    return errors;
  }

  render() {
    const {
      inputType,
      label,
      name,
      required,
      hideErrors,
      disabled,
    } = this.props;
    const { active, inputErrors, value } = this.state;
    const isInvalid = !hideErrors && (inputErrors.length > 0 || required);
    return (
      <div
        className={cx('input', { invalid: isInvalid }, this.props.className)}>
        <label className={active || value ? 'input-label show' : 'input-label'}>
          {label}
        </label>
        <input
          name={name}
          className="input-field"
          type={inputType || 'text'}
          value={value}
          onChange={e => this.handleChange(e)}
          onFocus={() => this.handleFocus()}
          onBlur={() => this.handleBlur()}
          ref={input => (this.inputField = input)}
          disabled={disabled}
        />
        {this.renderErrors()}
      </div>
    );
  }
}

Input.propTypes = {
  className: PropTypes.string,
  inputType: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  customValidation: PropTypes.func,
  required: PropTypes.bool,
  prefilled: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  disabled: PropTypes.bool,
  hideErrors: PropTypes.bool,
};

Input.defaultProps = {
  hideError: false,
};



// WEBPACK FOOTER //
// ./src/component/Forms/Input.jsx